<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span>Đơn vị cung cấp</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col xl="10" lg="9">
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="TRẠNG THÁI HIỆN TẠI CỦA CƠ SỞ"
                    prop="ngung_hoat_dong"
                  >
                    <div class="form-custom">
                      <el-radio
                        class="checkbox-active"
                        v-model="mData.dataForm.hoat_dong.ngung_hoat_dong"
                        @change="fn_chuyenTrangThaiHoatDong(false)"
                        :label="false"
                        :disabled="mData.notAllowToChange"
                        >HOẠT ĐỘNG</el-radio
                      >
                      <el-radio
                        class="checkbox-inactive"
                        v-model="mData.dataForm.hoat_dong.ngung_hoat_dong"
                        @change="fn_chuyenTrangThaiHoatDong(true)"
                        :label="true"
                        :disabled="mData.notAllowToChange"
                        >NGỪNG HOẠT ĐỘNG</el-radio
                      >
                      <span class="status-title" v-if="mData.notAllowToChange">
                        {{
                          mData.dataForm.hoat_dong &&
                          mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi
                            ? `Cơ sở kinh
                                        doanh chỉ được thay đổi trạng thái sau 7 ngày tính từ: ` +
                              new Intl.DateTimeFormat("vi-VN", options).format(
                                new Date(
                                  mData.dataForm.hoat_dong.thoi_diem_thay_doi_cuoi
                                )
                              )
                            : ""
                        }}
                      </span>
                    </div>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <el-form-item
                    label="Đơn vị cung cấp"
                    prop="du_lieu_khai_bao.user_ten"
                  >
                    <el-input
                      type="text"
                      v-model="mData.dataForm.du_lieu_khai_bao.user_ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col
                  md="2"
                  v-if="mData.dataForm.du_lieu_khai_bao.user_loai == 'hotel'"
                >
                  <el-form-item label="Số sao" prop="luu_tru.so_sao">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.luu_tru.so_sao"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col
                  md="4"
                  v-if="mData.dataForm.du_lieu_khai_bao.user_loai == 'ticket'"
                >
                  <el-form-item label="Loại hình" prop="ve_dien_tu.loai">
                    <el-select
                      v-model="mData.dataForm.ve_dien_tu.loai"
                      :placeholder="aLang.c_select"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listLoaiHinhVe"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
                <b-col
                  md="4"
                  v-if="
                    mData.dataForm.du_lieu_khai_bao.user_loai == 'restaurant'
                  "
                >
                  <el-form-item label="Dịch vụ" prop="am_thuc.dich_vu">
                    <el-select
                      v-model="mData.dataForm.am_thuc.dich_vu"
                      disabled
                      clearable
                      multiple
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listDichVu"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="2" lg="3">
              <b-col md="12">
                <el-form-item
                  class="mb-3"
                  label="Ảnh đại diện"
                  prop="du_lieu_khai_bao.user_anh"
                >
                  <el-upload
                    action
                    :auto-upload="false"
                    list-type="picture-card"
                    :limit="mData.fileUploadOption.AnhDaiDien.limit"
                    :accept="mData.fileUploadOption.AnhDaiDien.accept"
                    :on-change="fn_uploadChangeAnhDaiDien"
                    :on-preview="fn_uploadPreviewAnhDaiDien"
                    :on-remove="fn_uploadRemoveAnhDaiDien"
                    :on-exceed="fn_uploadExceedAnhDaiDien"
                    :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                    :disabled="mData.viewMode == 'detail'"
                    :class="[
                      mData.fileUploadOption.AnhDaiDien.fileList.length > 0
                        ? 'hidden-icon-upload'
                        : '',
                    ]"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog
                    :close-on-click-modal="true"
                    :visible.sync="
                      mData.fileUploadOption.AnhDaiDien.dialogVisible
                    "
                    width="60%"
                    top="51px"
                    title="Chi tiết"
                  >
                    <img
                      width="100%"
                      :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                      alt
                    />
                  </el-dialog>
                </el-form-item>
              </b-col>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Địa chỉ
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseDiaChi
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseDiaChi" visible>
                  <b-row>
                    <b-col md="6">
                      <b-row>
                        <b-col md="6">
                          <el-form-item
                            label="Tỉnh/Thành phố"
                            prop="du_lieu_khai_bao.dia_chi_tinh_id"
                          >
                            <el-select
                              v-model="
                                mData.dataForm.du_lieu_khai_bao.dia_chi_tinh_id
                              "
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listProvince"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <!-- <b-col md="6">
                          <el-form-item label="Quận/huyện" prop="du_lieu_khai_bao.dia_chi_huyen_id">
                            <el-select v-model="mData.dataForm.du_lieu_khai_bao.dia_chi_huyen_id"
                              :placeholder="aLang.c_select" :disabled="mData.viewMode == 'detail'" clearable filterable>
                              <el-option v-for="item in mData.dataDefault.listDistrict" :key="item.id"
                                :label="item.name" :value="item.id"></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col> -->
                        <b-col md="6">
                          <el-form-item
                            label="Xã/Phường"
                            prop="du_lieu_khai_bao.dia_chi_xa_id"
                          >
                            <el-select
                              v-model="
                                mData.dataForm.du_lieu_khai_bao.dia_chi_xa_id
                              "
                              :placeholder="aLang.c_select"
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                              filterable
                            >
                              <el-option
                                v-for="item in mData.dataDefault.listCommune"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                              ></el-option>
                            </el-select>
                          </el-form-item>
                        </b-col>
                        <b-col md="12">
                          <el-form-item
                            label="Địa chỉ"
                            prop="du_lieu_khai_bao.user_dia_chi"
                          >
                            <el-input
                              type="text"
                              v-model="
                                mData.dataForm.du_lieu_khai_bao.user_dia_chi
                              "
                              :disabled="mData.viewMode == 'detail'"
                              clearable
                            ></el-input>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col md="6">
                      <b-row>
                        <b-col>
                          <el-form-item label="Địa chỉ trên bản đồ">
                            <mapbox-component
                              :viewMode="mData.viewMode"
                              @update="fn_getDataFromMapboxComponent"
                              :cordinatesValue="mData.mapDataObject.value"
                              v-if="mData.dataDefault.showMap"
                              id="mapBox"
                            ></mapbox-component>
                          </el-form-item>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Người đại diện
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseNguoiDaiDien
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseNguoiDaiDien" visible>
                  <b-row>
                    <b-col md="3">
                      <el-form-item
                        label="Tên người đại diện"
                        prop="du_lieu_khai_bao.ho_ten"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.du_lieu_khai_bao.ho_ten"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item
                        label="Chức vụ"
                        prop="du_lieu_khai_bao.chuc_vu"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.du_lieu_khai_bao.chuc_vu"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item
                        label="Điện thoại"
                        prop="du_lieu_khai_bao.user_dien_thoai"
                      >
                        <el-input
                          type="text"
                          v-model="
                            mData.dataForm.du_lieu_khai_bao.user_dien_thoai
                          "
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item
                        label="Số CMTND/CCCD/Hộ chiếu"
                        prop="du_lieu_khai_bao.user_so_giay_to"
                      >
                        <el-input
                          type="text"
                          v-model="
                            mData.dataForm.du_lieu_khai_bao.user_so_giay_to
                          "
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  ALBUM
                  <div class="card-header-actions">
                    <b-link
                      class="card-header-action btn-minimize"
                      v-b-toggle.collapseAlbum
                      v-b-tooltip.hover
                      :title="aLang.c_toggle"
                    >
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseAlbum" visible>
                  <b-row class="mb-1">
                    <b-col md="3">
                      <el-form-item label="Ngôn ngữ" prop="ngon_ngu">
                        <el-select
                          v-model="mData.dataFormNew.ngon_ngu"
                          @change="
                            fn_changeLanguage(mData.dataFormNew.ngon_ngu)
                          "
                          :placeholder="aLang.c_select"
                          @input="forceUpdateUI"
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNgonNgu"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col md="12" class="d-flex-album">
                      <label class="label-image" style="margin-right: 10px"
                        >ALBUM ẢNH</label
                      >
                      <el-popover
                        style="color: #fff"
                        placement="bottom-start"
                        width="300"
                        trigger="click"
                      >
                        <el-link
                          href="javascript:"
                          class="warning-text"
                          slot="reference"
                          ><i class="el-icon-info" style="margin-right: 5px"></i
                          >Lưu ý khi tải ảnh</el-link
                        >
                        <div class="alert-message">
                          <p>
                            Hình ảnh sau khi đăng tải sẽ được thay đổi kích
                            thước để hiển thị phù hợp trên giao diện ứng dụng Du
                            lịch Việt Nam an toàn. Để chất lượng hình ảnh tối ưu
                            nhất, kích thước ảnh gốc khuyến khích sử dụng theo
                            tỷ lệ 2:3!
                          </p>
                        </div>
                      </el-popover>
                    </b-col>
                    <!-- :key="item.name" -->
                    <b-col
                      v-for="(item, index) in mData.dataFormNew.listImageUrl"
                      :key="index"
                      md="4"
                      xl="3"
                      :class="{
                        'text-center mt-2': true,
                        'hide-element-blank': !item.anh_id,
                      }"
                      v-if="showList"
                    >
                      <div class="position-css">
                        <el-image
                          fit="cover"
                          class="el-image-css"
                          :src="item.url"
                          :preview-src-list="mData.dataDefault.listAlbumImage"
                          :lazy="true"
                          v-if="!fn_checkVideo(item)"
                        >
                          <!-- <img :src="item.url.replace('&r=clip&w=400&h=600&ha=center','')" alt="" style="z-index:9999;"> -->
                          <div slot="error" class="el-image__error">
                            <span class="small" style="line-height: 1rem">{{
                              item.name ? item.name : ""
                            }}</span>
                          </div>
                        </el-image>
                        <div
                          style="position: relative; cursor: pointer"
                          v-if="fn_checkVideo(item)"
                          @click="fn_playVideo(item)"
                        >
                          <video class="video-css">
                            <source
                              :src="item.url"
                              :type="fn_changeType(item.type)"
                            />
                          </video>
                          <div class="play-icon-custom">
                            <i
                              class="fa fa-play play-icon-css"
                              aria-hidden="true"
                            ></i>
                          </div>
                        </div>
                        <el-tooltip
                          class="item"
                          effect="dark"
                          content="Click để xoá"
                          placement="top-end"
                        >
                          <div
                            class="remove-icon c-ponit"
                            @click="fn_uploadRemoveFile(item.anh_id)"
                          >
                            <el-image
                              style="width: 100%"
                              src="img/remove_icon.png"
                              fit="cover"
                            >
                            </el-image>
                          </div>
                        </el-tooltip>
                        <el-form-item
                          class="text-left mb-4 margin-auto"
                          label="Chú thích"
                        >
                          <el-input
                            @change="saveTemporaryAlbum"
                            class="mt-2"
                            type="textarea"
                            :rows="3"
                            maxlength="150"
                            show-word-limit
                            v-model="item.tieu_de"
                            clearable
                            @input="forceUpdateUI"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </b-col>
                    <b-col md="4" xl="3">
                      <el-form-item class="mb-3">
                        <el-upload
                          action
                          :auto-upload="false"
                          :show-file-list="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AlbumAnh.limit"
                          :accept="mData.fileUploadOption.AlbumAnh.accept"
                          :on-change="fn_uploadChangeAlbumAnh"
                          v-if="!mData.disableUpload"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <label class="label-infomation">THÔNG TIN CHI TIẾT</label>
                    </b-col>
                    <b-col md="12">
                      <el-form-item :label="'Nội dung'" prop="noi_dung">
                        <editor-component
                          :prop-data-editor="
                            mData.dataFormNew.noiDungHienThiFilter
                          "
                          :prop-data-editor-key="'noi_dung'"
                          :prop-data-editor-disabled="false"
                          @changePropDataEditor="saveTemporaryInformationDetail"
                        ></editor-component>
                      </el-form-item>
                    </b-col>
                    <!-- <b-col md="12">
                      <el-form-item label="Giới thiệu">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                          mData.dataFormNew.noiDungHienThiFilter.gioi_thieu
                          "
                          clearable
                          @input="forceUpdateUI"
                          @change="saveTemporaryInformationDetail"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item class="mb-3" label="Ảnh">
                        <el-upload
                          action
                          :auto-upload="false"
                          list-type="picture-card"
                          :limit="mData.fileUploadOption.AnhThongTin.limit"
                          :accept="mData.fileUploadOption.AnhThongTin.accept"
                          :on-change="fn_uploadChangeAnhThongTin"
                          :on-preview="fn_uploadPreviewAnhThongTin"
                          :on-remove="fn_uploadRemoveAnhThongTin"
                          :on-exceed="fn_uploadExceedAnhThongTin"
                          :file-list="mData.fileUploadOption.AnhThongTin.fileList"
                          :class="[mData.fileUploadOption.AnhThongTin.fileList.length > 0 ? 'hidden-icon-upload' : '']"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog
                          :close-on-click-modal="true"
                          :visible.sync="mData.fileUploadOption.AnhThongTin.dialogVisible"
                          width="60%"
                          top="51px"
                          title="Chi tiết"
                        >
                          <img
                            width="100%"
                            :src="mData.fileUploadOption.AnhThongTin.dialogImageUrl"
                            alt
                          />
                        </el-dialog>
                      </el-form-item>
                    </b-col>
                    <b-col md="12">
                      <el-form-item label="Nội dung">
                        <el-input
                          type="textarea"
                          :rows="3"
                          v-model="
                            mData.dataFormNew.noiDungHienThiFilter.noi_dung
                          "
                          clearable
                          @input="forceUpdateUI"
                          @change="saveTemporaryInformationDetail"
                        ></el-input>
                      </el-form-item>
                    </b-col> -->
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <!-- <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Ưu đãi cho khách du lịch
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseUuDaiKDL v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseUuDaiKDL" visible>
                  <p class="mb-0">Ưu đãi khi thanh toán bằng <span class="bold card__du-lich" @click="gotoNewPage">Thẻ
                      du lịch</span> trên tổng hóa đơn* </p>
                  <b-row>
                    <b-col md="4">
                      <el-form-item v-if="showSelectKDL" label="Loại hình ưu đãi"
                        prop="thong_tin_chung.loai_hinh_uu_dai">
                        <el-select v-model="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai"
                          placeholder="Chọn loại hình ưu đãi" clearable @change="changeTypeEndowKDL()"
                          @clear="clearTypeEndowKDL()"
                          @blur="validateFieldMethod(`thong_tin_chung.loai_hinh_uu_dai`)" @input="forceUpdateUI">
                          <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                            :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4" v-if="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai == 'giam_gia_tien'">
                      <el-form-item v-if="showMoneyElementUI" label="Giá trị ưu đãi (VND)"
                        prop="thong_tin_chung.gia_tri_uu_dai">
                        <ElementUiMoney v-model="mData.dataForm.thong_tin_chung.gia_tri_uu_dai" label=""
                          :placeholder="'Nhập giá trị ưu đãi'" :outlined="true" :clearable="true" :options="options1"
                          @input="forceUpdateUI()" :refProp="`thong_tin_chung.gia_tri_uu_dai`"
                          @blurInput="validateFieldMethod('thong_tin_chung.gia_tri_uu_dai')" />
                      </el-form-item>
                    </b-col>
                    <b-col md="4" v-if="mData.dataForm.thong_tin_chung.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                      <el-form-item v-if="show" label="Giá trị ưu đãi (%)" prop="thong_tin_chung.gia_tri_uu_dai">
                        <el-input v-model="mData.dataForm.thong_tin_chung.gia_tri_uu_dai" type="number"
                          placeholder="Nhập giá trị ưu đãi"
                          @change="changeShowInput(mData.dataForm.thong_tin_chung.gia_tri_uu_dai, 'mData.dataForm.thong_tin_chung.gia_tri_uu_dai')"
                          @input="forceUpdateUI()"></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-card>
                <div slot="header">
                  Ưu đãi cho hướng dẫn viên
                  <div class="card-header-actions">
                    <b-link class="card-header-action btn-minimize" v-b-toggle.collapseUuDaiHDV v-b-tooltip.hover
                      :title="aLang.c_toggle">
                      <i class="icon-arrow-up"></i>
                    </b-link>
                  </div>
                </div>

                <b-collapse id="collapseUuDaiHDV" visible>
                  <b-row>
                    <b-col md="4">
                      <el-form-item v-if="showSelectHDV" label="Loại hình ưu đãi"
                        prop="thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai">
                        <el-select v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai"
                          placeholder="Chọn loại hình ưu đãi" clearable @change="changeTypeEndowHDV()"
                          @blur="validateFieldMethod(`thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai`)"
                          @input="forceUpdateUI" @clear="clearTypeEndowHDV()">
                          <el-option v-for="item in mData.dataDefault.listLoaiHinhUuDai" :key="item.value"
                            :label="item.label" :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="4"
                      v-if="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_tien'">
                      <el-form-item v-if="showMoneyElementUI" label="Giá trị ưu đãi (VND)"
                        prop="thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai">
                        <ElementUiMoney v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                          label="" :placeholder="'Nhập giá trị ưu đãi'" :outlined="true" :clearable="true"
                          :options="options1" @input="forceUpdateUI()"
                          :refProp="`thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai`"
                          @blurInput="validateFieldMethod('thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')" />
                      </el-form-item>
                    </b-col>
                    <b-col md="4"
                      v-if="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai == 'giam_gia_phan_tram'">
                      <el-form-item v-if="show" label="Giá trị ưu đãi (%)"
                        prop="thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai">
                        <el-input v-model="mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
                          type="number" placeholder="Nhập giá trị ưu đãi"
                          @change="changeShowInput(mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai, 'mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai')"
                          @input="forceUpdateUI()"></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-collapse>
              </b-card>
            </b-col>
          </b-row> -->

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_updateAlbum(mData.dataFormNew.ngon_ngu)"
              v-ladda
            >
              Cập nhật album
            </el-button>
            <!-- <el-button
              :disabled="disabledButton()"
              type="info" plain @click="fn_updateEndowHDV()" v-ladda
              v-if="mData.dataForm.isActive && hasPermissionEditData">Cập nhật ưu đãi</el-button> -->
            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.dataForm.isActive && hasPermissionEditData"
              >Cập nhật thông tin đơn vị</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div
      style="
        position: fixed;
        width: 100%;
        height: 100%;
        background: rgba(80, 67, 67, 0.79);
        top: 0;
        left: 0;
        z-index: 99999;
      "
      v-if="mData.dataDefault.dialogVideo.show"
    >
      <div
        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); max-width: 80%, max-height: 80%;"
      >
        <video autoplay controls class="video-control">
          <source
            :src="mData.dataDefault.dialogVideo.src"
            :type="mData.dataDefault.dialogVideo.type"
          />
        </video>
      </div>
      <div
        style="position: absolute; right: 20px; top: 45px; cursor: pointer"
        @click="fn_closeDialogVideo()"
      >
        <i
          class="fa fa-times"
          style="font-size: 36px; color: #ffffff"
          aria-hidden="true"
        ></i>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import DDATModel from "@/views/admin/DDAT/DDATModel";
import ShareDuLieuKhaiBaoModel from "@/views/admin/ShareModel/ShareDuLieuKhaiBaoModel";
import ShareThongTinChungModel from "@/views/admin/ShareModel/ShareThongTinChungModel";
import DDATApi from "../../../moduleApi/DDATApi";
import MapComponent from "../../../component/MapComponent";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import MapboxComponent from "../../../component/MapboxComponent";
import DichVuAmThucApi from "@/moduleApi/DichVuAmThucApi";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import FileApi from "@/moduleApi/FileApi";
import DonViCungCapChoDuyetApi from "@/moduleApi/DonViCungCapChoDuyetApi";
import ApiService from "../../../service/ApiService";
import config from "../../../config.json";
import ElementUiMoney from "@/component/ElementUiMoney";
import ValidService from "../../../service/ValidService";
import EditorComponent from "../../../component/EditorComponent";

export default {
  components: {
    MapComponent,
    MapboxComponent,
    ElementUiMoney,
    EditorComponent,
  },
  data() {
    return {
      show: true,
      showSelectHDV: true,
      showSelectKDL: true,
      showMoneyElementUI: true,
      checked: false,
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      options1: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 100,
        precision: 0,
      },
      mData: {
        viewMode: "detail",
        moduleName: "ThongTinDDAT", //requied
        urlImg: ExtensionService.urlSurveyImg,
        tableRules: MethodService.copyObject(DDATModel.tableRules),
        dataDefault: {
          roles: DataService.roles,
          showMap: false,
          listGioiTinh: DataService.gioiTinh,
          listCountry: [],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listTieuChiAnToan: [],
          listLoaiHinh: MethodService.copyObject(DataService.loaiHinhRegister),
          listImageUrl: [],
          listDichVu: [],
          listLoaiHinhUuDai: [
            {
              value: "giam_gia_tien",
              label: "Giảm giá tiền",
            },
            {
              value: "giam_gia_phan_tram",
              label: "Giảm giá phần trăm",
            },
          ],
          listLoaiHinhVe: [
            {
              value: "air_plain_ticket",
              label: "Vé máy bay",
            },
            {
              value: "show_ticket",
              label: "Vé nghệ thuật biểu diễn",
            },
            {
              value: "transport_ticket",
              label: "Vé giao thông",
            },
          ],
          listNgonNgu: DataService.Languages,
          listAlbumImage: [],
          dialogVideo: {
            show: false,
            src: "",
            type: "",
          },
        },
        albumAnhFilter: [
          {
            anh_id: undefined,
            tieu_de: undefined,
          },
        ],
        dataForm: {
          hoat_dong: {
            ngung_hoat_dong: undefined,
          },
          du_lieu_khai_bao: MethodService.copyObject(ShareDuLieuKhaiBaoModel),
          thong_tin_chung: MethodService.copyObject(
            ShareThongTinChungModel.dataForm
          ),
        },
        dataFormNew: MethodService.copyObject(DDATModel.dataForm),
        dataFormEndow: {
          loai_hinh_uu_dai: undefined,
          gia_tri_uu_dai: undefined,
        },
        validFormEndow: {
          loai_hinh_uu_dai: [ValidService.requiredChange],
          gia_tri_uu_dai: [ValidService.required],
        },
        ifHavePermission: false,
        ifHavePermissionEdit: false,
        validForm: DDATModel.validForm,
        validFormOther: DDATModel.validFormOther,
        fileUploadOption: MethodService.copyObject(
          DDATModel.dataFormOther.fileUploadOption
        ),
        dataPropMapDiaDiem: {
          fn_addLatLng: this.fn_addLatLngDiaDiem,
          lat: "",
          lng: "",
          showMap: false,
          id: "MapDiaDiem",
        },
        mapDataObject: {
          value: [107.9, 14.01667],
          geoJson: {
            type: "",
            coordinates: [],
          },
        },
        notAllowToChange: false,
        isActive: true,
        disableUpload: false,
      },
      currentUser: JSON.parse(localStorage.getItem("currentUser")),
      hasPermissionEditData: true,
      typeVideo: ["mp4", "avi", "mov"],
      typeImage: ["jpg", "png", "jpeg"],
      typeAccept: ["mp4", "avi", "mov", "jpg", "png", "jpeg"],
      showList: true,
    };
  },
  async mounted() {
    await this.fn_initData();
    await this.checkPermission();
    let dichVuRes = await DichVuAmThucApi.list({
      limit: 100,
    });
    if (dichVuRes.result) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.mData.dataDefault.listDichVu = dichVuRes.result.map((item) => {
        return { value: item.id, label: item.ten_vi };
      });
    }
  },

  methods: {
    validateFieldMethod(prop) {
      this.$refs["myForm"].validateField(prop);
      if (
        prop == "thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai" ||
        prop == "thong_tin_chung.gia_tri_uu_dai"
      ) {
        this.showMoneyElementUI = false;
        setTimeout(() => {
          this.showMoneyElementUI = true;
        }, 10);
      }
    },
    changeShowInput(data, field) {
      if (!data) return;
      this.show = false;
      if (parseInt(data) > 100) {
        if (
          field ==
          "mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
        )
          this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
            "100";
        if (field == "mData.dataForm.thong_tin_chung.gia_tri_uu_dai")
          this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = "100";
      } else if (parseInt(data) === 0) {
        if (
          field ==
          "mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai"
        )
          this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
            undefined;
        if (field == "mData.dataForm.thong_tin_chung.gia_tri_uu_dai")
          this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined;
      }
      setTimeout(() => {
        this.show = true;
      }, 10);
    },
    checkValid(data) {
      if (!data) return;
      setTimeout(() => {
        this.showMoneyElementUI = false;
        setTimeout(() => {
          this.showMoneyElementUI = true;
        }, 10);
      }, 1000);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    disabledButton() {
      // return (!this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai || !this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai) &&
      //   (!this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai || !this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai)
      return false;
    },
    changeTypeEndowHDV() {
      if (
        !this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai
          .loai_hinh_uu_dai
      )
        return;
      // this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai = [ValidService.required]
      this.showSelectHDV = false;
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
        undefined;
      setTimeout(() => {
        this.showSelectHDV = true;
      }, 1);
    },
    clearTypeEndowHDV() {
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai =
        undefined;
      this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
        undefined;
      this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
        [];
    },
    changeTypeEndowKDL() {
      if (!this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai) return;
      // this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [ValidService.required]
      this.showSelectKDL = false;
      this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined;
      setTimeout(() => {
        this.showSelectKDL = true;
      }, 1);
    },
    clearTypeEndowKDL() {
      this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = undefined;
      this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = undefined;
      this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [];
    },
    fn_updateEndowHDV() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          console.log(
            "this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai",
            this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai
          );
          console.log(
            "this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai",
            this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai
              .gia_tri_uu_dai
          );
          if (
            !this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai
              .gia_tri_uu_dai
          )
            this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai.loai_hinh_uu_dai =
              undefined;
          if (!this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai)
            this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = undefined;
          let dataUuDaiHDv = {
            id: this.mData.dataFormNew.id,
            loai_hinh_uu_dai:
              this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai
                .loai_hinh_uu_dai,
            gia_tri_uu_dai: this.mData.dataForm.thong_tin_chung.huong_dan_vien
              .uu_dai.gia_tri_uu_dai
              ? parseFloat(
                  this.mData.dataForm.thong_tin_chung.huong_dan_vien.uu_dai
                    .gia_tri_uu_dai
                )
              : undefined,
          };
          let dataUuDai = {
            id: this.mData.dataFormNew.id,
            loai_hinh_uu_dai:
              this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai,
            gia_tri_uu_dai: this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai
              ? parseFloat(this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai)
              : undefined,
          };
          try {
            await DDATApi.updateUuDai(dataUuDai);
            await DDATApi.updateHdvUuDai(dataUuDaiHDv);
            this.fn_initData();
          } catch (error) {
            console.info(error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    gotoNewPage() {
      window.open("http://thedulich.gov.vn/", "_blank").focus();
    },
    validatePercent(rule, value, callback) {
      if (value > 100) {
        callback(new Error("Phần trăm không quá 100%"));
      } else {
        callback();
      }
    },
    changeTypeEndow(type) {
      if (type == "giam_gia_phan_tram") {
        this.mData.validFormEndow.gia_tri_uu_dai = [
          ValidService.required,
          {
            validator: this.validatePercent,
            trigger: "blur",
          },
        ];
      } else {
        this.mData.validFormEndow.gia_tri_uu_dai = [ValidService.required];
      }
      this.mData.dataFormEndow.gia_tri_uu_dai = undefined;
    },
    //Chuyển trạng thái hoạt động
    fn_chuyenTrangThaiHoatDong(trangThai) {
      let message = "";
      if (trangThai) {
        message =
          "<p>Bạn có chắc muốn chuyển trạng thái thành CƠ SỞ TẠM NGỪNG HOẠT ĐỘNG hay không?</p>" +
          "<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>";
      } else {
        message =
          "<p>Bạn có chắc muốn chuyển trạng thái thành HOẠT ĐỘNG hay không?</p>" +
          "<p>Lưu ý: Bạn chỉ có thể chuyển lại trạng thái thành hoạt động sau ít nhất 7 ngày kể từ khi thực hiện chuyển đổi này!</p>";
      }
      this.$confirm(message, "", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: LanguageService.lang.c_agree,
        cancelButtonText: LanguageService.lang.c_cancel,
        type: "warning",
      })
        .then(async () => {
          let data = {
            id: this.mData.dataForm.id,
            hoat_dong: {
              ngung_hoat_dong: trangThai,
            },
          };
          try {
            await ApiService.patch(
              config.hostApiDuLich +
                "diem_den_an_toans/" +
                this.mData.dataForm.id,
              data
            ).then(() => {
              window.location.href = "admin/ThongTinDDAT/detail";
            });
          } catch (error) {
            console.info("ERROR : ", error.toString());
          }
          this.fn_initDataDefault();
          this.$forceUpdate();
        })
        .catch(() => {
          this.mData.dataForm.hoat_dong.ngung_hoat_dong = !trangThai;
        });
    },
    fn_submitForm() {
      this.$router.push({
        name: "Admin-ThongTinDDAT-update",
        params: { id: this.mData.dataForm.id },
      });
    },
    //get data
    async fn_initData() {
      this.mData.dataDefault.listProvince = [];
      this.mData.dataDefault.listDistrict = [];
      this.mData.dataDefault.listCommune = [];
      let currentUser = MethodService.getCurrentUser();

      let dataFilter = {
        filters: "nguoi_tao_id=" + currentUser.id,
        // this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-detail",
          })
          .catch(() => {});
      }
      this.mData.ifHavePermission = false;
      this.mData.ifHavePermissionEdit = true;
      let res = await DDATApi.list(dataFilter);
      if (res.result) {
        if (!res.result[0].noi_dung_hien_thi)
          res.result[0].noi_dung_hien_thi = [];
        if (!res.result[0].album) res.result[0].album = [];
        this.mData.dataFormNew = res.result[0];
        this.mData.dataFormNew.ngon_ngu = "vi";
        this.fn_changeLanguage(this.mData.dataFormNew.ngon_ngu);
        let donViCungCapRes = await DonViCungCapApi.findById(res.result[0].id);
        if (donViCungCapRes.result) {
          this.mData.dataForm = donViCungCapRes.result;
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai: undefined,
                gia_tri_uu_dai: undefined,
              },
            },
          };
          if (
            donViCungCapRes.result.thong_tin_chung.huong_dan_vien.uu_dai
              .loai_hinh_uu_dai
          ) {
            this.mData.validForm.thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai =
              [ValidService.required];
          }
          if (donViCungCapRes.result.thong_tin_chung.loai_hinh_uu_dai) {
            this.mData.validForm.thong_tin_chung.gia_tri_uu_dai = [
              ValidService.required,
            ];
          }
          if (
            res.result[0].hoat_dong == undefined ||
            res.result[0].hoat_dong.ngung_hoat_dong == undefined
          ) {
            this.mData.dataForm.hoat_dong = { ngung_hoat_dong: false };
          } else {
            this.mData.dataForm.hoat_dong = res.result[0].hoat_dong;
            // this.mData.dataForm.hoat_dong.ngung_hoat_dong =  true;
          }
          if (
            res.result[0].hoat_dong == undefined ||
            res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined
          ) {
            this.mData.notAllowToChange = false;
          } else {
            let todayTime = new Date().getTime();
            let lastTimeChange = new Date(
              res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi
            ).getTime();
            let totalTimeChange =
              (todayTime - lastTimeChange) / 1000 / 60 / 60 / 24;

            if (totalTimeChange < 7) {
              this.mData.notAllowToChange = true;
            } else {
              this.mData.notAllowToChange = false;
            }
          }

          if (
            res.result[0].du_lieu_khai_bao &&
            res.result[0].du_lieu_khai_bao.user_anh
          ) {
            let data = {};
            data = {
              id: res.result[0].du_lieu_khai_bao.user_anh,
              name: res.result[0].du_lieu_khai_bao.user_anh,
              url:
                ExtensionService.urlSurveyImg +
                res.result[0].du_lieu_khai_bao.user_anh +
                "&r=square&w=512",
            };
            this.mData.fileUploadOption.AnhDaiDien.fileList = [data];
          }
          if (
            res.result[0].du_lieu_khai_bao &&
            res.result[0].du_lieu_khai_bao.toa_do
          ) {
            this.mData.dataForm.du_lieu_khai_bao.toa_do =
              res.result[0].du_lieu_khai_bao.toa_do.split(",");
            this.mData.dataForm.du_lieu_khai_bao.kinh_do =
              this.mData.dataForm.du_lieu_khai_bao.toa_do[0];
            this.mData.dataForm.du_lieu_khai_bao.vi_do =
              this.mData.dataForm.du_lieu_khai_bao.toa_do[1];
            this.mData.dataPropMapDiaDiem.lat =
              this.mData.dataForm.du_lieu_khai_bao.vi_do;
            this.mData.dataPropMapDiaDiem.lng =
              this.mData.dataForm.du_lieu_khai_bao.kinh_do;
            this.mData.dataPropMapDiaDiem.showMap = true;

            let coordinate = [
              this.mData.dataForm.du_lieu_khai_bao.kinh_do,
              this.mData.dataForm.du_lieu_khai_bao.vi_do,
            ];
            this.mData.mapDataObject.value = coordinate;
            this.mData.mapDataObject.geoJson.type = "Point";
            this.mData.mapDataObject.geoJson.coordinates = coordinate;
            this.mData.dataDefault.showMap = true;
          }

          if (
            res.result[0].thong_tin_chung.nguoi_dai_dien.ho_ten == undefined ||
            res.result[0].thong_tin_chung.nguoi_dai_dien.chuc_vu == undefined
          ) {
            this.$confirm(
              "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
              {
                confirmButtonText: LanguageService.lang.c_agree,
                showClose: false,
                showCancelButton: false,
                type: "warning",
              }
            ).then(() => {
              this.$router.push({
                name: "Admin-" + this.mData.moduleName + "-update",
                params: { id: res.result[0].id },
              });
              if (res.result[0].thong_tin_chung.dia_chi == undefined) {
                this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do = 105.850176;
                this.mData.dataForm.thong_tin_chung.dia_chi.vi_do = 21.0287797;
                this.mData.dataDefault.showMap = true;
              }
            });
          } else {
            let shouldUpdate = false;
            if (
              res.result[0].du_lieu_khai_bao &&
              res.result[0].du_lieu_khai_bao.dia_chi_tinh_id
            ) {
              let resProvince = await ProvinceApi.findById(
                res.result[0].du_lieu_khai_bao.dia_chi_tinh_id
              );
              this.mData.dataDefault.listProvince.push(resProvince.result);
            }

            if (
              res.result[0].du_lieu_khai_bao &&
              !res.result[0].du_lieu_khai_bao.dia_chi_xa_id
            ) {
              shouldUpdate = true;
            } else {
              let resCommune = await CommuneApi.findById(
                res.result[0].du_lieu_khai_bao.dia_chi_xa_id
              );
              if (resCommune.result.disabled) {
                shouldUpdate = true;
              } else this.mData.dataDefault.listCommune.push(resCommune.result);
            }
            if (shouldUpdate) {
              this.$confirm(
                "Từ ngày 01/07/2025, theo nghị quyết về sắp xếp đơn vị hành chính cấp xã của Quốc hội, địa chỉ (Phường/Xã) của bạn có sự thay đổi. Xin vui lòng cập nhật lại thông tin địa giới hành chính mới.",
                {
                  confirmButtonText: "Cập nhật",
                  cancelButtonText: "Để sau",
                  type: "info",
                }
              ).then(() => {
                this.$router.push({
                  name: "Admin-ThongTinDDAT-update",
                  params: { id: res.result[0].id },
                });
              });
            }
          }
          if (this.mData.dataForm.hoat_dong.ngung_hoat_dong) {
            this.mData.dataForm.isActive = false;
          } else {
            this.mData.dataForm.isActive = true;
          }
        } else {
          const donViCungCapChoDuyetRes =
            await DonViCungCapChoDuyetApi.findById(res.result[0].id);
          if (donViCungCapChoDuyetRes.result) {
            this.mData.dataForm = donViCungCapChoDuyetRes.result;
            this.mData.dataForm.thong_tin_chung = {
              huong_dan_vien: {
                uu_dai: {
                  loai_hinh_uu_dai: undefined,
                  gia_tri_uu_dai: undefined,
                },
              },
            };
            if (
              res.result[0].hoat_dong == undefined ||
              res.result[0].hoat_dong.ngung_hoat_dong == undefined
            ) {
              this.mData.dataForm.hoat_dong = { ngung_hoat_dong: false };
            } else {
              this.mData.dataForm.hoat_dong = res.result[0].hoat_dong;
              // this.mData.dataForm.hoat_dong.ngung_hoat_dong =  true;
            }
            if (
              res.result[0].hoat_dong == undefined ||
              res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi == undefined
            ) {
              this.mData.notAllowToChange = false;
            } else {
              let todayTime = new Date().getTime();
              let lastTimeChange = new Date(
                res.result[0].hoat_dong.thoi_diem_thay_doi_cuoi
              ).getTime();
              let totalTimeChange =
                (todayTime - lastTimeChange) / 1000 / 60 / 60 / 24;

              if (totalTimeChange < 7) {
                this.mData.notAllowToChange = true;
              } else {
                this.mData.notAllowToChange = false;
              }
            }
            if (
              res.result[0].du_lieu_khai_bao &&
              res.result[0].du_lieu_khai_bao.user_anh
            ) {
              let data = {};
              data = {
                id: res.result[0].du_lieu_khai_bao.user_anh,
                name: res.result[0].du_lieu_khai_bao.user_anh,
                url:
                  ExtensionService.urlSurveyImg +
                  res.result[0].du_lieu_khai_bao.user_anh +
                  "&r=square&w=512",
              };
              this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
            }
            if (
              res.result[0].du_lieu_khai_bao &&
              res.result[0].du_lieu_khai_bao.toa_do
            ) {
              this.mData.dataForm.du_lieu_khai_bao.toa_do =
                this.mData.dataForm.du_lieu_khai_bao.toa_do.split(",");
              this.mData.dataForm.du_lieu_khai_bao.kinh_do =
                this.mData.dataForm.du_lieu_khai_bao.toa_do[0];
              this.mData.dataForm.du_lieu_khai_bao.vi_do =
                this.mData.dataForm.du_lieu_khai_bao.toa_do[1];
              this.mData.dataPropMapDiaDiem.lat =
                this.mData.dataForm.du_lieu_khai_bao.vi_do;
              this.mData.dataPropMapDiaDiem.lng =
                this.mData.dataForm.du_lieu_khai_bao.kinh_do;
              this.mData.dataPropMapDiaDiem.showMap = true;

              let coordinate = [
                this.mData.dataForm.du_lieu_khai_bao.kinh_do,
                this.mData.dataForm.du_lieu_khai_bao.vi_do,
              ];
              this.mData.mapDataObject.value = coordinate;
              this.mData.mapDataObject.geoJson.type = "Point";
              this.mData.mapDataObject.geoJson.coordinates = coordinate;
              this.mData.dataDefault.showMap = true;
            }

            if (
              res.result[0].thong_tin_chung.nguoi_dai_dien.ho_ten ==
                undefined ||
              res.result[0].thong_tin_chung.nguoi_dai_dien.chuc_vu == undefined
            ) {
              this.$confirm(
                "Bạn chưa khai báo đầy đủ thông tin điểm đến, vui lòng khai báo trước khi truy cập tính năng này!",
                {
                  confirmButtonText: LanguageService.lang.c_agree,
                  showClose: false,
                  showCancelButton: false,
                  type: "warning",
                }
              ).then(() => {
                this.$router.push({
                  name: "Admin-" + this.mData.moduleName + "-update",
                  params: { id: res.result[0].id },
                });
                if (res.result[0].thong_tin_chung.dia_chi == undefined) {
                  this.mData.dataForm.thong_tin_chung.dia_chi.kinh_do = 105.850176;
                  this.mData.dataForm.thong_tin_chung.dia_chi.vi_do = 21.0287797;
                  this.mData.dataDefault.showMap = true;
                }
              });
            } else {
              let shouldUpdate = false;
              if (
                res.result[0].du_lieu_khai_bao &&
                res.result[0].du_lieu_khai_bao.dia_chi_tinh_id
              ) {
                let resProvince = await ProvinceApi.findById(
                  res.result[0].du_lieu_khai_bao.dia_chi_tinh_id
                );
                this.mData.dataDefault.listProvince.push(resProvince.result);
              }
              if (
                res.result[0].du_lieu_khai_bao &&
                !res.result[0].du_lieu_khai_bao.dia_chi_xa_id
              ) {
                shouldUpdate = true;
              } else {
                let resCommune = await CommuneApi.findById(
                  res.result[0].du_lieu_khai_bao.dia_chi_xa_id
                );
                if (resCommune.result.disabled) {
                  shouldUpdate = true;
                } else
                  this.mData.dataDefault.listCommune.push(resCommune.result);
              }
              if (shouldUpdate) {
                this.$confirm(
                  "Từ ngày 01/07/2025, theo nghị quyết về sắp xếp đơn vị hành chính cấp xã của Quốc hội, địa chỉ (Phường/Xã) của bạn có sự thay đổi. Xin vui lòng cập nhật lại thông tin địa giới hành chính mới.",
                  {
                    confirmButtonText: "Cập nhật",
                    cancelButtonText: "Để sau",
                    type: "info",
                  }
                ).then(() => {
                  this.$router.push({
                    name: "Admin-ThongTinDDAT-update",
                    params: { id: res.result[0].id },
                  });
                });
              }
            }
            if (this.mData.dataForm.hoat_dong.ngung_hoat_dong) {
              this.mData.dataForm.isActive = false;
            } else {
              this.mData.dataForm.isActive = true;
            }
          }
        }
        this.showSelect = false;
        if (!res.result[0].thong_tin_chung.huong_dan_vien) {
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai: undefined,
                gia_tri_uu_dai: undefined,
              },
            },
          };
        } else if (
          res.result[0].thong_tin_chung.huong_dan_vien.uu_dai &&
          (res.result[0].thong_tin_chung.huong_dan_vien.uu_dai
            .loai_hinh_uu_dai ||
            res.result[0].thong_tin_chung.huong_dan_vien.uu_dai.gia_tri_uu_dai)
        ) {
          this.checked = true;
          this.mData.dataForm.thong_tin_chung = {
            huong_dan_vien: {
              uu_dai: {
                loai_hinh_uu_dai:
                  res.result[0].thong_tin_chung.huong_dan_vien.uu_dai
                    .loai_hinh_uu_dai,
                gia_tri_uu_dai:
                  res.result[0].thong_tin_chung.huong_dan_vien.uu_dai
                    .gia_tri_uu_dai,
              },
            },
          };
        }
        this.mData.dataForm.thong_tin_chung.loai_hinh_uu_dai = res.result[0]
          .thong_tin_chung.loai_hinh_uu_dai
          ? res.result[0].thong_tin_chung.loai_hinh_uu_dai
          : undefined;
        this.mData.dataForm.thong_tin_chung.gia_tri_uu_dai = res.result[0]
          .thong_tin_chung.gia_tri_uu_dai
          ? res.result[0].thong_tin_chung.gia_tri_uu_dai
          : undefined;
      }
      setTimeout(() => {
        this.showSelect = true;
      }, 10);
    },

    checkPermission() {
      if (
        this.currentUser.roles.includes("SafePlace") &&
        this.mData.dataForm.loai == "ticket" &&
        (this.mData.dataForm.ve_dien_tu.loai.includes("air_plain_ticket") ||
          this.mData.dataForm.ve_dien_tu.loai.includes("transport_ticket"))
      ) {
        this.hasPermissionEditData = false;
      }
    },

    //xử lý dữ liệu đầu ra
    async changeData() {},
    fn_getDataFromMapboxComponent(value) {
      this.mData.mapDataObject = value;
    },
    //click button
    fn_handle(type, scope, row) {
      if (type == "create") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
    },
    fn_go() {
      this.$router.go(-1);
    },

    //event table

    fn_formatterDate(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    fn_formatterRoles(row, column, cellValue) {
      let roles = "";
      cellValue.forEach((item) => {
        for (const element of this.mData.dataDefault.roles) {
          if (item == element.value) {
            item = element.label;
            roles += item + " ,";
          }
        }
      });
      roles = roles.slice(0, -1);
      return roles;
    },

    async fn_initDataDefault() {},

    fn_hashUrl() {},
    fn_download(file) {
      // this.mData.fileUploadOption.FileDinhKem.dialogImageUrl = file.url;
      // this.mData.fileUploadOption.FileDinhKem.dialogVisible = true;

      window.open(ExtensionService.urlSurveyFile + file.id);
    },
    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.du_lieu_khai_bao.user_anh = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
      this.$refs["myForm"].validateField("du_lieu_khai_bao.user_anh");
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "DDAT")
        .then((res) => {
          this.mData.dataForm.du_lieu_khai_bao.user_anh = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
          this.$refs["myForm"].validateField("du_lieu_khai_bao.user_anh");
        })
        .catch(() => {
          this.$refs["myForm"].validateField("du_lieu_khai_bao.user_anh");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },

    // Album ảnh
    fn_uploadCheckFileImageSize(file) {
      return MethodService.checkFileSize(file, 10);
    },
    //up load videolistImageUrl
    fn_uploadCheckFileVideoSize(file) {
      return MethodService.checkFileSize(file, 50);
    },

    fn_filterImageUrl(arrImage) {
      let imageExtension = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tiff",
        "webp",
        "svg",
      ];
      let imageUrls = arrImage
        .filter(
          (x) =>
            typeof x.type == "string" &&
            imageExtension.includes(x.type.toLowerCase())
        )
        .map((a) => a.url);
      this.mData.dataDefault.listAlbumImage = imageUrls;
      for (let i = 0; i < this.mData.dataDefault.listAlbumImage.length; i++) {
        this.mData.dataDefault.listAlbumImage[i] =
          this.mData.dataDefault.listAlbumImage[i].replace(
            "&r=clip&w=400&h=600&ha=center",
            ""
          );
      }
    },

    fn_checkTypeFile(fileType) {
      return MethodService.checkFileType(fileType);
    },

    fn_checkCountFile(fileList, typeFile) {
      if (this.typeVideo.includes(typeFile)) {
        if (
          fileList.filter((e) => this.typeVideo.includes(e.type)).length == 3
        ) {
          window.toastr.info("Chỉ tải lên tối đa 3 video");
          return false;
        } else {
          return true;
        }
      } else {
        if (
          fileList.filter((e) => !this.typeVideo.includes(e.type)).length == 10
        ) {
          window.toastr.info("Chỉ tải lên tối đa 10 ảnh");
          return false;
        } else {
          return true;
        }
      }
    },
    fn_disableUploadFile(fileList) {
      this.mData.disableUpload = fileList.length === 13;
    },
    fn_uploadChangeAlbumAnh(file, fileList) {
      console.log("file", file);
      let fileType = file.name
        .substr(file.name.length - 4, 4)
        .replace(".", "")
        .toLowerCase();
      if (!this.typeAccept.includes(fileType)) {
        window.toastr.warning(
          "Định dạng file hỗ trợ mp4, avi, mov, jpg, png, jpeg! Vui lòng tải các file đúng định dạng!"
        );
        return;
      }
      let item = {};
      let listImage = [];
      if (
        this.fn_checkTypeFile(fileType) &&
        this.fn_uploadCheckFileImageSize(file)
      ) {
        if (this.fn_uploadCheckFileVideoSize(file)) {
          this.mData.albumAnhFilter = this.mData.dataFormNew.listImageUrl;
          if (!this.fn_checkCountFile(this.mData.albumAnhFilter, fileType)) {
            return;
          }
          ExtensionService.upload(file, "anhAlbum")
            .then((res) => {
              this.mData.albumAnhFilter.push({
                anh_id: res.result,
                tieu_de: undefined,
                type: fileType,
                ngon_ngu: this.mData.dataFormNew.ngon_ngu,
              });
              for (const element of this.mData.albumAnhFilter) {
                element.url =
                  ExtensionService.urlImg +
                  element.anh_id +
                  "&r=clip&w=400&h=600&ha=center";
                item = {
                  name: element.anh_id,
                  anh_id: element.anh_id,
                  ngon_ngu: this.mData.dataFormNew.ngon_ngu,
                  tieu_de: element.tieu_de,
                  type: element.type,
                };
                item.url =
                  ExtensionService.urlImg +
                  element.anh_id +
                  (this.typeImage.includes(item.type)
                    ? "&r=clip&w=400&h=600&ha=center"
                    : "");
                listImage.push(item);
              }
              this.mData.dataFormNew.listImageUrl = listImage;
              this.saveTemporaryAlbum();
              this.fn_filterImageUrl(this.mData.albumAnhFilter);
              this.fn_disableUploadFile(this.mData.dataFormNew.listImageUrl);
            })
            .catch(() => {});
        }
      } else {
        if (this.typeVideo.includes(fileType)) {
          window.toastr.warning("Chỉ tải lên video không quá 50MB");
        } else {
          window.toastr.warning("Chỉ tải lên ảnh không quá 10MB");
        }
      }
    },
    saveTemporaryAlbum() {
      let arrIndex = [];
      this.mData.dataFormNew.album.filter((e, index) => {
        if (e.ngon_ngu == this.mData.dataFormNew.ngon_ngu && e.anh_id) {
          arrIndex.push(index);
          return e;
        }
      });
      for (let i = arrIndex.length - 1; i >= 0; i--) {
        this.mData.dataFormNew.album.splice(arrIndex[i], 1);
      }
      for (const element of this.mData.dataFormNew.listImageUrl) {
        this.mData.dataFormNew.album.push(element);
      }
    },
    saveTemporaryInformationDetail() {
      console.log(
        "this.mData.dataFormNew.noiDungHienThiFilter",
        this.mData.dataFormNew.noiDungHienThiFilter
      );
      let thongTin = this.mData.dataFormNew.noi_dung_hien_thi.find(
        (e) => e.ngon_ngu == this.mData.dataFormNew.ngon_ngu
      );
      if (!thongTin) {
        this.mData.dataFormNew.noi_dung_hien_thi.push(
          this.mData.dataFormNew.noiDungHienThiFilter
        );
      } else {
        // this.mData.dataFormNew.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataFormNew.ngon_ngu).gioi_thieu = this.mData.dataFormNew.noiDungHienThiFilter.gioi_thieu;
        // this.mData.dataFormNew.noi_dung_hien_thi.find(e => e.ngon_ngu == this.mData.dataFormNew.ngon_ngu).anh_id = this.mData.dataFormNew.noiDungHienThiFilter.anh_id;
        this.mData.dataFormNew.noi_dung_hien_thi.find(
          (e) => e.ngon_ngu == this.mData.dataFormNew.ngon_ngu
        ).noi_dung = this.mData.dataFormNew.noiDungHienThiFilter.noi_dung;
      }
    },
    fn_uploadRemoveAnhThongTin(file, fileList) {
      this.mData.dataFormNew.noiDungHienThiFilter.anh_id = null;
      this.mData.fileUploadOption.AnhThongTin.fileList = [];
      this.saveTemporaryInformationDetail();
      this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
    },
    fn_uploadChangeAnhThongTin(file, fileList) {
      ExtensionService.upload(file, "anhHienThi")
        .then((res) => {
          this.mData.dataFormNew.noiDungHienThiFilter.anh_id = res.result;
          this.mData.fileUploadOption.AnhThongTin.fileList = fileList;
          this.saveTemporaryInformationDetail();
          this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
        })
        .catch((error) => {
          this.$refs["myForm"].validateField("noiDungHienThiFilter.anh_id");
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhThongTin(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhThongTin.limit} file`
      );
    },
    fn_uploadPreviewAnhThongTin(file) {
      this.mData.fileUploadOption.AnhThongTin.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhThongTin.dialogVisible = true;
    },
    fn_changeLanguage(lang) {
      this.mData.fileUploadOption.AnhThongTin.fileList = [];
      this.mData.dataFormNew.noiDungHienThiFilter =
        this.mData.dataFormNew.noi_dung_hien_thi.find(
          (e) => e.ngon_ngu == lang
        );
      if (!this.mData.dataFormNew.noiDungHienThiFilter) {
        this.mData.dataFormNew.noiDungHienThiFilter = {
          // gioi_thieu: null,
          // anh_id: undefined,
          noi_dung: null,
        };
      } else if (
        this.mData.dataFormNew.noiDungHienThiFilter &&
        this.mData.dataFormNew.noiDungHienThiFilter.anh_id
      ) {
        let dataImg = {
          id: this.mData.dataFormNew.noiDungHienThiFilter.anh_id,
          name: this.mData.dataFormNew.noiDungHienThiFilter.anh_id,
          url:
            ExtensionService.urlImg +
            this.mData.dataFormNew.noiDungHienThiFilter.anh_id +
            "&r=square&w=512",
        };
        this.mData.fileUploadOption.AnhThongTin.fileList = [];
        this.mData.fileUploadOption.AnhThongTin.fileList.push(dataImg);
      }
      this.mData.dataFormNew.noiDungHienThiFilter.ngon_ngu = lang;
      this.fn_album(lang);
    },
    fn_album(lang) {
      this.mData.albumAnhFilter = this.mData.dataFormNew.album.filter(
        (e) => e.ngon_ngu == lang && e.anh_id
      );
      this.fn_disableUploadFile(this.mData.albumAnhFilter);
      if (this.mData.albumAnhFilter && this.mData.albumAnhFilter.length > 0) {
        let listImage = [];
        for (const element of this.mData.albumAnhFilter) {
          element.url =
            ExtensionService.urlImg +
            element.anh_id +
            "&r=clip&w=400&h=600&ha=center";
          let item = {};
          item = {
            name: element.anh_id,
            anh_id: element.anh_id,
            tieu_de: element.tieu_de,
            ngon_ngu: lang,
            type: element.type,
          };
          item.url =
            ExtensionService.urlImg +
            element.anh_id +
            (this.typeImage.includes(item.type)
              ? "&r=clip&w=400&h=600&ha=center"
              : "");
          listImage.push(item);
        }
        this.mData.dataFormNew.listImageUrl = listImage;
        this.fn_filterImageUrl(this.mData.albumAnhFilter);
      } else {
        this.mData.dataFormNew.listImageUrl = [
          {
            name: undefined,
            anh_id: undefined,
            tieu_de: undefined,
            ngon_ngu: lang,
            type: undefined,
          },
        ];
      }
    },
    fn_checkVideo(item) {
      return item && item.type && this.typeVideo.includes(item.type);
    },
    fn_changeType(extension) {
      if (extension) {
        return "video/" + extension.replace(".", "");
      }
      return "";
    },
    fn_playVideo(item) {
      this.mData.dataDefault.dialogVideo.src = item.url;
      this.mData.dataDefault.dialogVideo.type = this.fn_changeType(item.type);
      this.mData.dataDefault.dialogVideo.show = true;
    },
    fn_closeDialogVideo() {
      this.mData.dataDefault.dialogVideo.src = "";
      this.mData.dataDefault.dialogVideo.type = "";
      this.mData.dataDefault.dialogVideo.show = false;
    },
    fn_uploadRemoveFile(fileId) {
      this.showList = false;
      this.mData.dataFormNew.listImageUrl =
        this.mData.dataFormNew.listImageUrl.filter((e) => e.anh_id != fileId);
      this.saveTemporaryAlbum();
      this.fn_disableUploadFile(this.mData.dataFormNew.listImageUrl);
      this.showList = true;
    },
    async fn_updateAlbum(lang) {
      // console.log('this.mData.dataFormNew.album.filter(x => x.anh_id)', this.mData.dataFormNew.album.filter(x => x.anh_id));
      const data = {
        id: this.mData.dataFormNew.id,
        noi_dung_hien_thi: this.mData.dataFormNew.noi_dung_hien_thi,
        album: this.mData.dataFormNew.album.filter((x) => x.anh_id),
      };
      let arrIndex = [];
      let thongTin = data.noi_dung_hien_thi.find((e) => e.ngon_ngu == lang);
      data.album.filter((e, index) => {
        if (e.ngon_ngu == lang && e.anh_id) {
          arrIndex.push(index);
          return e;
        }
      });

      if (!thongTin) {
        data.noi_dung_hien_thi.push(
          this.mData.dataFormNew.noiDungHienThiFilter
        );
      } else {
        // data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang).gioi_thieu = this.mData.dataFormNew.noiDungHienThiFilter.gioi_thieu;
        // data.noi_dung_hien_thi.find(e => e.ngon_ngu == lang).anh_id = this.mData.dataFormNew.noiDungHienThiFilter.anh_id;
        data.noi_dung_hien_thi.find((e) => e.ngon_ngu == lang).noi_dung =
          this.mData.dataFormNew.noiDungHienThiFilter.noi_dung;
      }
      for (let i = arrIndex.length - 1; i >= 0; i--) {
        data.album.splice(arrIndex[i], 1);
      }
      for (const element of this.mData.dataFormNew.listImageUrl) {
        data.album.push(element);
      }
      data.album = data.album.filter((x) => x.anh_id);
      console.log("data update", data);
      await DDATApi.updateAlbumImage(data);
    },
    // End album ảnh
  },

  created() {
    this.fn_initDataDefault();
    this.fn_hashUrl();
  },
  computed: {
    options() {
      return {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-link {
  display: flex !important;
  justify-content: flex-start !important;
}

::v-deep .el-link--inner {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.card__du-lich {
  color: #409eff;
}

.card__du-lich:hover {
  cursor: pointer;
  text-decoration: underline;
}

.endow .el-dialog__body {
  padding: 15px;
}

.el-message-box {
  width: 95%;

  @media (min-width: 576px) {
    width: 420px;
  }
}

.status-title {
  font-style: italic;
}

.form-custom {
  display: flex;
  flex-direction: column;
}

.checkbox-inactive {
  line-height: 24px;
}

.checkbox-active > span.el-radio__label {
  text-transform: uppercase;
  // color: rgb(63, 219, 16);
}

.checkbox-active .el-radio__input.is-disabled + span.el-radio__label {
  text-transform: uppercase;
  // color: rgb(63, 219, 16);
  // color: blue;
}

.checkbox-active .is-checked + span.el-radio__label {
  text-transform: uppercase;
  // color: rgb(63, 219, 16);
  font-weight: bold;
}

.checkbox-inactive > span.el-radio__label {
  text-transform: uppercase;
  // color: red;
}

.checkbox-inactive .is-checked + span.el-radio__label {
  text-transform: uppercase;
  // color: red;
  font-weight: bold;
}

.checkbox-inactive
  .el-radio__input.is-disabled.is-checked
  + span.el-radio__label {
  text-transform: uppercase;
  // color: red;
  color: #409eff;
}

.checkbox-active
  .el-radio__input.is-disabled.is-checked
  + span.el-radio__label {
  text-transform: uppercase;
  // color: red;
  color: #409eff;
}
</style>
